<template>
    <div class="for-whom-page">
        <IdSection :title="titleIdSection" :info="infoIdSection" />

        <section class="section" style="padding-top: 50px;">
            <div class="container">
                <div class="row">
                    <div class="thinking font-bold font-italic">
                        <div class="content">
                            “Desde sua criação a plataforma é um encontro poderoso de pessoas da periferia e das suas
                            histórias de resistência e criatividade. Esta ferramenta permite, por exemplo, que um jovem
                            que toca um projeto de agroecologia e hortas comunitárias no extremo leste da cidade de São
                            Paulo possa se conectar com a coordenadora de um grande instituto que invista nesta causa. E
                            por outro lado, queremos que uma Fundação possa buscar em um único lugar diversos projetos
                            das periferias que tem o objetivo de alcançar a igualdade de gênero utilizando os filtros
                            das ODS, por exemplo”
                        </div>
                    </div>

                    <div class="thinking">
                        <div class="content"><br>
                            Anderson Meneses, co-diretor da Agência Mural<br />
                            de Jornalismo das Periferias e integrante da<br />
                            Rede Potências Periféricas em entrevista ao<br />Fundo BIS.
                        </div>
                        <p><br>A plataforma é destinada tanto para investidores como para potências das periferias de todo o Brasil, permitindo encontros e trocas entre todas!</p>
                    </div>
                </div>
            </div>
        </section>

        <section>
            <TextImgVideoSection
                :useImg="false"
                :useSecondText="true"
                titleColor="yellow"
                titleColor2="blue"
                :title="'ALGUNS TIPOS DE POTÊNCIAS'"
                :title2="'ALGUNS TIPOS DE INVESTIDORES'"
                :content="
                    `<ul>
                        <li>Associações</li>
                        <li>Bancos Comunitários</li>
                        <li>Coletivos</li>
                        <li>Cooperativas</li>
                        <li>Fundações</li>
                        <li>Iniciativas formais e informais</li>
                        <li>Institutos</li>
                        <li>Movimentos</li>
                        <li>Negócios de impacto</li>
                        <li>Negócios sociais</li>
                        <li>Pequenos empreendedores (formais ou informais) tais como, mas não limitado a artistas, produtores de conteúdo, artesãos, etc,</li>
                        <li>Redes</li>
                    </ul>`
                "
                :content2="
                    `<ul>
                        <li>Associações</li>
                        <li>Empresas</li>
                        <li>Fundações</li>
                        <li>Fundos</li>
                        <li>Institutos</li>
                    </ul>`
                "
            />
        </section>

        <section>
            <TextImgVideoSection
                :useImg="false"
                :title="null"
                :isAllWidth="true"
                :content="
                    `
                    <div>Com seu cadastro e interação, a plataforma permitirá que você:</div>
                    <ul>
                        <li>Visualize todos os tipos de iniciativas (formais, informais, empreendedores, redes, etc.)</li>
                        <li>Acesse mapa com diferentes camadas (redes, parcerias, IDH, favelas, matas, etc) (FUTURAMENTE)</li>
                        <li>Estabeleça conexões com outras iniciativas</li>
                        <li>Legitimar e fortalecer as relações entre os doadores e iniciativas</li>
                        <li>Utilize múltiplas possibilidades de filtros</li>
                        <li>Encontre em um único local informações sobre as potências periféricas, prestadores de serviços, negócios ou produtos das periferias</li>
                        <li>Avalie e  apoie as iniciativas com as quais já trabalhou, desenvolvendo a confiança e a possibilidade das iniciativas realizarem outras conexões</li>
                    </ul>
                    `
                "
            />
        </section>
        <section>
            <TextImgVideoSection
                :useImg="true"
                :title="'Principais benefícios para cada perfil'"
                :content="
                    `
                    <div><b>Para as potências periféricas:</b></div>
                    <ul>
                        <li>Maior visibilidade do seu trabalho, causa e incidência;</li>
                        <li>Um perfil de atuação que tenha todas as informações sobre a iniciativa, suas conexões, recomendações, etc.;</li>
                        <li>Descobrir quem são os doadores do ecossistema;</li>
                        <li>Possibilidade de conexões entre as próprias potências;</li>
                        <li>Com a utilização de um algoritmo, visualizar quais iniciativas têm maior compatibilidade com seu trabalho.</li>
                    </ul>

                    <div><b>Para os investidores sociais:</b></div>
                    <ul>
                        <li>Um lugar único para encontrar os projetos, coletivos e instituições, formais e informais;</li>
                        <li>Qualificar o público foco, temáticas e territórios para investir seus recursos;</li>
                        <li>Facilidade na mobilização do público específico para uma chamada pública (edital, prêmio, desafio);</li>
                        <li>Legitimar e fortalecer as relações entre os doadores e as potências periféricas;</li>
                        <li>Organização e filtragem de iniciativas, projetos e causas.</li>
                    </ul>
                    `
                "
            />
        </section>
    </div>
</template>

<script>
import IdSection from '@//pages/public/components/landing-page/id-section/IdSection'
import TextImgVideoSection from '@/pages/public/components/landing-page/text-img-video-section/TextImgVideoSection'

export default {
    components: { IdSection, TextImgVideoSection },
    data() {
        return {
            titleIdSection: 'Para quem é',
            infoIdSection: ``
        }
    }
}
</script>

<style scope src="./ForWhomPage-light-theme.css"></style>
<style scope src="./ForWhomPage-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/public/for-whom-page/ForWhomPage.vue